// Override Settings
var window_url = window.location.href;
var product_limit=null;
if(window_url.includes("?view=")){
  var split_window_url = window_url.split("?");
  var get_limit=split_window_url[1].split("=");
  var final_limit =get_limit[1];
  product_limit = final_limit; 
//   console.log("final_limit",final_limit);
}else
{
  product_limit=boostPFSConfig.custom.products_per_page;
}
var boostPFSFilterConfig = {
  general: {
    limit: product_limit,
    /* Optional */
    loadProductFirst: true,
    refineByStyle: 'style2',
    filterTreeMobileStyle: 'style1'
  },
};

var isFirstLoad = boostPFSFilterConfig.general.loadProductFirst;

// Declare Templates
var boostPFSTemplate = {
  // Grid Template
  'productGridItemHtml': '<div data-product-handle={{itemHandle}} id="{{itemHandle}}" class="grid__item grid-product ' + boostPFSConfig.custom.grid_item_width + ' {{itemQuickShopClass}}" data-aos="row-of-' + boostPFSConfig.custom.products_per_row + '">' +
  '<div class="grid-product__content">' +
  '{{itemLabel}}' +
  '<a href="{{itemUrl}}" class="grid-product__link {{itemSoldOutClass}}">' +
  '<div class="grid-product__image-mask">'+
  '{{itemQuickShopButton}}' +
  '{{itemImages}}'+
  '{{itemSwatchHoverImages}}' +
  '</div>' +
  '</a>' +
  '<div class="grid-product__colors grid-product__colors--{{itemId}}" >'+
  '{{item_tag_colorSwatch}}'+
  '</div>'+
//   '{{itemSwatch}}' +
  '<div class="grid-product__meta grid-product__meta--{{itemId}}">' +
  '<div class="grid-product__title">{{itemTitle}}</div>' +
  
  '{{itemVendor}}' +
  '<div class="grid-product__description">{{itemDescription}}</div>'+
  '<div class="grid-product__price">{{itemPrice}}</div>' +
  '{{reviewHtml}}'+
  '</div>' +
  '</div>' +
  /*' <div class="grid-product__sizes  grid-product__sizes--{{itemId}}" >'+
  '{{itemSizeSwatch}}'+
  '</div>'+*/
  '{{itemSwatchSelect}}'+
//   '{{addToCartBtnWithWishList}}'+
  '</div>',

  // Pagination Template
  //	'previousActiveHtml': '<span class="prev"><a href="{{itemUrl}}" title=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg><span class="icon__fallback-text">Previous</span></a></span>',
  'previousActiveHtml': '<span class="prev"><a href="{{itemUrl}}" title=""><span>Previous Page</span></a></span>',
  'previousDisabledHtml': '',
  //'nextActiveHtml': '<span class="next"><a href="{{itemUrl}}" title=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg><span class="icon__fallback-text">Next</span></a></span>',
  'nextActiveHtml': '<span class="next"><a href="{{itemUrl}}" title=""><span>Next Page</span></a></span>',
  'nextDisabledHtml': '',
  'pageItemHtml': '<span class="page"><a href="{{itemUrl}}" title="">{{itemTitle}}</a></span>',
  'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
  'pageItemRemainHtml': '<span class="deco">...</span>',
  'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

  // Sorting Template
  'sortingHtml': '<label for="boost-pfs-filter-top-sorting-select" class="open-sort-dropdown">' + boostPFSConfig.label.sorting+" by" + '</label><select class="boost-pfs-filter-top-sorting-select">{{sortingItems}}</select>',
};


(function() {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  /************************** BUILD PRODUCT LIST **************************/

  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function(data, index) {
    
    if (!data) data = this.data;
    if (!index) index = this.index;
    
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    // Add Thumbnail
    var aspectRatio = images.length > 0 ? images[0]['width'] / images[0]['height'] : '';
    var paddingBottom = images.length > 0 ? 100 / aspectRatio : '100';
    var thumb = images.length > 0 ? images[0] : boostPFSConfig.general.no_image_url;
    var productGridImageFillClass = '';
    if(boostPFSConfig.custom.hasOwnProperty('product_grid_image_fill') && boostPFSConfig.custom.product_grid_image_fill){
      productGridImageFillClass = 'grid__image-contain product-image--main';
    }
    var itemImagesHtml = '';
    if (boostPFSConfig.custom.product_grid_image_size == 'natural') {
      itemImagesHtml += '<div class="image-wrap" style="height: 0; padding-bottom: ' + paddingBottom + '%;">';
      itemImagesHtml += '<img ' +
        'class="grid-product__image lazyload image-'+data.id+'" ' +
        'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
        'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
        'data-aspectratio="' + aspectRatio + '" ' +
        'data-sizes="auto" ' +
        'alt="{{itemTitle}}">';
      itemImagesHtml += '<noscript>' +
        '<img class="grid-product__image lazyloaded image-'+data.id+'" ' +
        'src="' + Utils.getFeaturedImage(images, '400x') + '" ' +
        'alt="{{itemTitle}">' +
        '</noscript>';
      itemImagesHtml += '</div>';

    } else {
      itemImagesHtml += '<div class="grid__image-ratio grid__image-ratio--' + boostPFSConfig.custom.product_grid_image_size + '" >';
      itemImagesHtml += '<img ' +
        'class="lazyload ' + productGridImageFillClass + ' image-'+data.id+'" ' +
        'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
        'data-widths="[360, 540, 720, 900, 1080]" ' +
        'data-aspectratio="' + aspectRatio + '" ' +
        'data-sizes="auto" ' +
        'alt="{{itemTitle}}">';
      itemImagesHtml += '</div>';
    }

    if (!soldOut) {
      if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
        itemImagesHtml += '<div class="grid-product__secondary-image small--hide">';
        itemImagesHtml += '<img class="lazyload image-'+data.id+'"' +
          'data-src="' + Utils.optimizeImage(images[1].src, '{width}x') + '"' +
          'data-widths="[360, 540, 720, 900, 1080]"' +
          'data-aspectratio="' + aspectRatio + '"' +
          'data-sizes="auto"' +
          'alt="{{itemTitle}}">';
        itemImagesHtml += '</div>';
      }
    }

    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
      itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
      itemPriceHtml += '<span class="grid-product__price--original">' + Utils.formatMoney(data.compare_at_price_min) + '&nbsp;' + Shopify.currency.active + '</span>';
      itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>';
    }
    /*if (priceVaries) {
      itemPriceHtml += boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min));
    } else {
      itemPriceHtml += Utils.formatMoney(data.price_min);
    }*/
    itemPriceHtml += '<span class="grid-product__price--regular">'+ Utils.formatMoney(data.price_min)+" "+Shopify.currency.active +'</span>';
    if (onSale && boostPFSConfig.custom.product_save_amount) {
      var savePrice = '';
      if (boostPFSConfig.custom.product_save_type == 'dollar') {
        savePrice = Utils.formatMoney(data.compare_at_price_min - data.price_min);
      } else {
        savePrice = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_min);
        savePrice += '%';
      }
      savePrice +='&nbsp;'+Shopify.currency.active;
      var savePriceText = boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice);
//       itemPriceHtml += '<span class="grid-product__price--savings">' + savePriceText + '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add soldOut class
    var itemSoldOutClass = soldOut ? 'grid-product__link--disabled' : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add label
    var customLabel = '';
    data.tags.forEach(function(tag) {
      if (tag.startsWith('_label_')) {
        if (!customLabel) {
          customLabel = tag.replace('_label_', '');
        }
      }
    });
    var itemLabelHtml = '';
    if (customLabel) {
      itemLabelHtml = '<div class="grid-product__tag grid-product__tag--custom grid-product__'+ customLabel +' ">' + customLabel + '</div>';
    } else {
      // soldOut Label
      if (soldOut) {
        itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sold-out">' + boostPFSConfig.label.sold_out + '</div>';
      } else if (onSale) {
        itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sale">' + boostPFSConfig.label.sale + '</div>';
      }
    }
    itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? '<div class="grid-product__vendor">' + data.vendor + '</div>' : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
    //Add Description{{itemDescription}}
//     console.log(data);
    var desc_data = null;
    if(data.body_html.includes("-----")){
      var split_desc_data = data.body_html.split("-----");
      desc_data = split_desc_data[0];
    }else{
      desc_data = data.body_html;
    }
    
//     console.log(desc_data);
    
//     var itemDescriptionHtml = '<div class="grid-product__description">' + desc_data + '</div>';
//     itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescriptionHtml);
    
   	//product title
    var p_title_split_first = null ;
    var p_title_split_last = null ;
    var split_title = data.title.split(" - ");
    p_title_split_first = split_title[0];
	p_title_split_last = split_title[1];
    
    var product_title = '<div class="grid-product__title">'+ p_title_split_first +'</div>';
    var itemDescriptionHtml = '<div class="grid-product__description">' + p_title_split_last + '</div>';
//     console.log("product_title:----",product_title,"itemDescriptionHtml:---",itemDescriptionHtml);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, p_title_split_first);
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, p_title_split_last);
    
    
    // Add Quick shop
    var itemQuickShopClass = '';
    var itemQuickShopButtonHtml = '';
    if (boostPFSConfig.custom.quick_shop_enable && !soldOut) {
      itemQuickShopClass = 'grid-product__has-quick-shop';
      itemQuickShopButtonHtml = '<div class="quick-product__btn js-modal-open-quick-modal-{{itemId}} small--hide ' + (isFirstLoad ? '' : 'bc-hide') + '" data-product-id="{{itemId}}">' +
        '<span class="quick-product__label">' + boostPFSConfig.label.quick_shop + '</span>' +
        '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);
    itemHtml = itemHtml.replace(/{{itemQuickShopButton}}/g, itemQuickShopButtonHtml);

    // Review
    var reviewHtml = '';
    if (boostPFSConfig.custom.enable_product_reviews) {
      reviewHtml = '<span class="shopify-product-reviews-badge" data-id="' + data.id + '"></span>';
    }
    itemHtml = itemHtml.replace(/{{reviewHtml}}/g, reviewHtml);

    // Color swatch
    var swatchHtml = buildSwatch(data, this,'color');
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, swatchHtml.itemSwatch);
    itemHtml = itemHtml.replace(/{{itemSwatchHoverImages}}/g, swatchHtml.itemSwatchHoverImages);
    
    //Custom Color Swatch
	var customSwatchHtml = buildSwatch(data, this,'customSwatch');
    itemHtml = itemHtml.replace(/{{item_tag_colorSwatch}}/g, customSwatchHtml.customColorSwatchHtml);
    
    
    
    
    
    //Size Swatch    
//     var size_swatchHtml = buildSwatch(data, this,'size');
//     itemHtml = itemHtml.replace(/{{itemSizeSwatch}}/g, size_swatchHtml.swatchItemsSize);
    
    
    var swatchHtmlSelectOption = buildSwatch(data, this,'selectoption');
    itemHtml = itemHtml.replace(/{{itemSwatchSelect}}/g, swatchHtmlSelectOption.select_option_html);
    

    // Add to Cart Button with wishlist
//     var addToCartBtn = buildAddToCartWithWishListButton(data, this);
//     itemHtml = itemHtml.replace(/{{addToCartBtnWithWishList}}/g, addToCartBtn.cta_btn);
    var itemQuickShopModal = '';

    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable) {
      itemQuickShopModal = '<div id="QuickShopModal-{{itemId}}" class="modal modal--square modal--quick-shop" data-product-id="{{itemId}}">' +
        '<div class="modal__inner">' +
        '<div class="modal__centered">' +
        '<div class="modal__centered-content">' +
        '<div id="QuickShopHolder-{{itemHandle}}"></div>' +
        '</div>' +

        '<button type="button" class="modal__close js-modal-close text-link">' +
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg>' +
        '<span class="icon__fallback-text">Close Modal</span>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopModal}}/g, itemQuickShopModal);


    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

    return itemHtml;
  };

  // Build Swatch
  function buildSwatch(data, _this,swatch_name) {
    var itemSwatchHtml = '';
    var itemSwatchHoverImagesHtml = '';
    var sizeitemSwatchHtml = '';
    var customColorSwatchHtml = '';
    if (boostPFSConfig.custom.collection_color_swatches) {
      var swatchItems = [];
      var swatchItemsSize = [];
      var swatchHoverImages = [],
          customColorSwatch = [];
      
//       console.log("options_with_values ",data.options_with_values.length)
      
      if(swatch_name == "selectoption"){
        if(data.options_with_values.length == 1){
          var havesize = false;
        }else{
          var havesize = true;
        }
        var compareprise=Utils.formatMoney(data.compare_at_price_min) + '&nbsp;' + Shopify.currency.active;
        var select_option_html = '<select id="product-variants-'+data.id+'" class="visually-hidden" data-havesize="'+havesize+'">';
        data.variants.forEach(function(variant) {
          var original_price = Utils.formatMoney(variant.price) + '&nbsp;' + Shopify.currency.active;
          select_option_html += '<option value="'+variant.id+'" '+
            'data-variant-url="/products/'+data.handle+'?variant='+variant.id+'" '+
            'data-variant-title="'+variant.title+'" '+
            'data-available="'+variant.available+'" '+
            'data-variant-image="'+variant.image+'" '+
            "data-variant-price='"+original_price+"' data-compare-price='"+compareprise+"'></option>";
        });
        select_option_html += '<select>';
      }
      
      data.options_with_values.forEach(function(option, index) {
        var option_name = option.name.toLowerCase();
        
        
        if(swatch_name == "color"){
          if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1) {
            var option_index = index;
            var values = [];
            var count_color = 0;
            data.variants.forEach(function(variant) {
              //             console.log(variant)
              var value = variant.merged_options[option_index].split(':')[1];
              if (values.indexOf(value) == -1) {
                values.push(value);
                var colorValueSlugify = Utils.slugify(value);
                var colorImage = Utils.optimizeImage(boostPFSAppConfig.general.asset_url.replace('boost-pfs.js', colorValueSlugify + '.png'), '50x');
                //               var variantImage = Utils.optimizeImage(variant.image, '400x');
                var variantImage = '';

                if(variant.image != null){
                  variantImage = variant.image;
                }

                var add_selected = '';
                if(count_color == 0){
                  add_selected = "selected";
                }

                //               var swatchItem = '<a href="{{itemUrl}}?variant={{variantId}}" ' +
                //                   'class="color-swatch color-swatch--small color-swatch--{{colorValueSlugify}} {{swatchClass}}" ' +
                //                   'data-variant-id="{{variantId}}" ' +
                //                   'data-variant-image="{{variantImage}}" ' +
                //                   'style="background-image: url({{colorImage}}); background-color: {{backgroundColor}};"> ' +
                //                   '</a>';
                var swatchItem = 
                    '<a href="javascript:void(0);" '+
                    'class="color-swatch color-swatch--small product_swatch_color color-swatch--brown color-swatch--with-image '+add_selected+'"'+
                    'data-product-id="'+data.id+'" '+
                    'data-variant-id="'+ variant.id +'"'+
                    'data-variant-image="'+variantImage+'"'+
                    'data-variant-title="'+value+'"'+
                    'style="background-image: url({{colorImage}}); background-color: {{backgroundColor}};">'+
                    '<span class="visually-hidden">Brown</span>'+
                    '</a>';



                swatchItem = swatchItem.replace(/{{variantId}}/g, variant.id);
                swatchItem = swatchItem.replace(/{{colorValueSlugify}}/g, colorValueSlugify);
                swatchItem = swatchItem.replace(/{{swatchClass}}/g, variant.image ? 'color-swatch--with-image' : '');
                swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
                swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);
                swatchItem = swatchItem.replace(/{{backgroundColor}}/g, colorValueSlugify.split('-').pop());

                var swatchHoverImage = '<div class="grid-product__color-image grid-product__color-image--' + variant.id + ' small--hide"></div>';

                swatchItems.push(swatchItem);
                swatchHoverImages.push(swatchHoverImage);
                count_color ++;
              }
            });
          }
        }
        if(swatch_name == "size"){
          var option_index = index;
//           console.log("Size",option_index,option_name,"DATA ---",data)
          
          
          if (option_name.indexOf('size') != -1 || option_name.indexOf('size') != -1) {
          var option_index = index;
          var values = [];
          var count_size = 0;
          data.variants.forEach(function(variant) {
            var value = variant.merged_options[option_index].split(':')[1];
            if (values.indexOf(value) == -1) {
              values.push(value);
              var colorValueSlugify = Utils.slugify(value);
              var add_disableClass = '',
                  add_selected = '',
                  tmp = 0;
              
              
              if(variant.available == false){
                add_disableClass = 'disable';
              }
              
              if(variant.available == true){
                count_size ++;
                tmp ++;
              }
              
              if(count_size == 1 && tmp == 1){
                add_selected = "selected";
              }

              //               var swatchItem = '<a href="{{itemUrl}}?variant={{variantId}}" ' +
              //                   'class="color-swatch color-swatch--small color-swatch--{{colorValueSlugify}} {{swatchClass}}" ' +
              //                   'data-variant-id="{{variantId}}" ' +
              //                   'data-variant-image="{{variantImage}}" ' +
              //                   'style="background-image: url({{colorImage}}); background-color: {{backgroundColor}};"> ' +
              //                   '</a>';
              
              
//               console.log("Image :: ",variant.image)
              var variantImage = '';
              if(variant.image != null){
                variantImage = variant.image;
              }
              
              var sizeSwatchItem = '<a href="javascript:void(0);"'+
                  'class="size-swatch size-swatch--small product_swatch_size '+add_disableClass+' size-swatch--xs '+add_selected+'"'+
                  'data-product-id="'+data.id+'"'+
                  'data-variant-id="'+ variant.id +'"'+
                  'data-variant-image="'+variantImage+'">'+
                  '<span>'+value+'</span>'+
                  '</a>';
              



              sizeSwatchItem = sizeSwatchItem.replace(/{{variantId}}/g, variant.id);
              sizeSwatchItem = sizeSwatchItem.replace(/{{colorValueSlugify}}/g, colorValueSlugify);
              sizeSwatchItem = sizeSwatchItem.replace(/{{backgroundColor}}/g, colorValueSlugify.split('-').pop());
              
              swatchItemsSize.push(sizeSwatchItem);
            }
          });
        }
          
          
        }
        
      });
      
//       console.log("-->  ",swatch_name)
      if(swatch_name == 'customSwatch_false'){
        var product_tags = data.tags
        if(product_tags.length > 0){
          product_tags.forEach(function(tag){
            if(tag.includes("color=")){
              var split_tags = tag.split("="),
                  color_name = split_tags[1],
                  product_handle = split_tags[2],
                  color_image_name = color_name.toLowerCase()+'.png',
                  product_url = boostPFSAppConfig.shop.url+ '/products/'+product_handle,
                  color_image_url = Utils.optimizeImage(boostPFSAppConfig.general.file_url.replace("/files/?",'/files/'+color_image_name+'?'), '50x');

              var prod_image = '';
              $.ajax({
                url:product_url+'.json',
                type:'GET',
                async: false,
                success:function(prod_data){
                  var product = prod_data['product'];
//                   console.log("SUCCESS ::\n",prod_data,product.images[0]);
                  prod_image = product.images[0].src;
                },
                error:function(error){
//                   console.log("ERROR ::\n",error);
                }
              });


              var customItem = 
                  '<a href="'+product_url+'" '+
                  'class="color-swatch custom-color--swatch custom-color-swatch color-swatch--small color-swatch--brown color-swatch--with-image"'+
                  'data-product-handle="'+product_handle+'"'+
                  'data-product-id="'+data.id+'" '+
                  'data-variant-id="'+ data.variants[0].id +'"'+
                  'data-product--image="'+prod_image+'"'+
                  'data-current-product--image="'+data.images[1]+'"'+
                  'style="background-image: url('+color_image_url+'); background-color:'+color_name+';">'+
                  '<span class="visually-hidden">'+color_name+'</span>'+
                  '</a>';

              customColorSwatch.push(customItem)
            }
          });
        }
      }
      if (swatchItems.length > 1) {
        itemSwatchHtml = ' <div class="grid-product__colors grid-product__colors--{{itemId}}" >' + swatchItems.join('') + '</div>';
        itemSwatchHoverImagesHtml = swatchHoverImages.join('');
      }
      if(swatchItemsSize.length >= 1){
        sizeitemSwatchHtml = swatchItemsSize.join('');
      }
      if(customColorSwatch.length > 0){
        customColorSwatchHtml = customColorSwatch.join('');
      }
    }
    return {
      itemSwatch: itemSwatchHtml,
      itemSwatchHoverImages: itemSwatchHoverImagesHtml,
      swatchItemsSize: sizeitemSwatchHtml,
      select_option_html:select_option_html,
      customColorSwatchHtml:customColorSwatchHtml
    };
  }

  function buildAddToCartWithWishListButton (data, _this){
//     console.log("DATA :::",data,data.title);
    var addToCartHtml = "";
    var variant_id = "";
    var cta_text = $("#product_addToCart_text").val();
    var remove_wishlist = false;
    var btn_class = "";
    var btn_url="javascript:;"
    var add_perent_class='',
        select_option_id = "#product-variants-"+data.id;
        btn_class="btn btn--full single-prod-btn";
    
    var first_available = '';
    for(var i = 0; i<data.variants.length ; i++){
      if(data.variants[i].available == true){
        first_available = data.variants[i];
        break;
      }
    }
    var variant_id = first_available.id;
    
//     console.log("variant_id----",variant_id)
    
    if(variant_id == undefined){
      cta_text = $("#product_BIS_text").val();
      btn_class="btn btn--full disabled";
      btn_url=Utils.buildProductItemUrl(data);
      add_perent_class='btn-disable';
    }
    
//         variant_id = data.variants[0].id;
    
    /*if(data.variants[0].available === true){
        btn_class="btn btn--full single-prod-btn";
      }
    else{
        cta_text = "EMAIL WHEN AVAILABLE";
        btn_class="btn btn--full disabled";
        
        var select_option_id = "#product-variants-"+data.id;
        
        var nextAllOptions = $(select_option_id+" option[value='"+variant_id+"']").nextAll(),
            nextAllOptions_length = nextAllOptions.length,
            variant_url = '';
        
        if(nextAllOptions_length > 0){
          var hase_available = false,
              available_data = '';
          nextAllOptions.each(function(){
            var this_available = $(this).data("available");
            if(this_available == true){
              hase_available = true;
              available_data = $(this);
              return false;
            }
          })
          if(hase_available == true){
            variant_url = available_data.data("variant-url");
          }else{
            variant_url = $(select_option_id+" option[data-available='true'").data("variant-url");
          }

        }else{
          //             console.log("else")
          var hase_available = false,
              available_data = '';
          $(select_option_id+" option").each(function(){
            var this_available = $(this).data("available");
            if(this_available == true){
              hase_available = true;
              available_data = $(this);
              return false;
            }
          });
          if(hase_available == true){
            variant_url = available_data.data("variant-url");
          }
        }
        
        
        btn_url=variant_url;
//         btn_url=Utils.buildProductItemUrl(data);
        add_perent_class='btn-disable';
      }*/
    
     var btn_wishlist='<button class="swym-button swym-add-to-wishlist-view-product product_'+ data.id +' swym-icon swym-heart disabled swym-added swym-loaded" data-swaction="addToWishlist" data-product-id="' + data.id + '" aria-label="Add to Wishlist">'+
      '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-wishlist icon--full-color" viewBox="0 0 29.7 26.3">'+
      '<path d="M15.1,26.3l-0.4-0.3c-0.2-0.2-0.4-0.4-0.6-0.5c-3.8-3.9-7.6-7.7-11.3-11.6c-2.7-2.8-3.5-6.1-2-9.2'+
      'c1.2-2.8,3.9-4.6,6.9-4.6c2.9-0.2,5.7,1.4,7.1,4.1c0.1,0.1,0.1,0.2,0.2,0.3C15,4.4,15,4.3,15,4.2C16,2.4,17.6,1,19.6,0.4'+
      'c2-0.6,4.1-0.5,5.9,0.5c0.2,0.1,0.3,0.2,0.5,0.3c3.7,2.2,4.9,7,2.7,10.7c-0.1,0.1-0.2,0.3-0.3,0.4c-0.3,0.4-0.6,0.8-0.9,1.2'+
      'L15.1,26.3z M8.1,1.1c-0.1,0-0.3,0-0.4,0c-2.7,0-5,1.6-6,4C0.4,7.9,1,10.7,3.5,13.2c3.7,3.9,7.5,7.7,11.3,11.6'+
      'c0.1,0.1,0.1,0.1,0.2,0.2l11.7-12.1c0.3-0.3,0.6-0.7,0.8-1.1c0.1-0.1,0.2-0.3,0.2-0.4c1.9-3.2,0.9-7.4-2.3-9.4'+
      'c-0.1-0.1-0.3-0.2-0.4-0.2c-1.6-0.8-3.4-1-5.1-0.4c-1.7,0.5-3.1,1.7-3.9,3.3c-0.2,0.3-0.3,0.7-0.6,1.2l-0.4,0.9l-0.5-0.9'+
      'c-0.1-0.2-0.2-0.4-0.3-0.6C14.1,5,14,4.8,13.8,4.6C12.7,2.4,10.5,1.1,8.1,1.1z"></path>'+
      '</svg>'+
      '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-wishlist-full icon--full-color" viewBox="0 0 29.7 26.3">'+
      '<path d="M28.7,11.9c-0.1,0.1-0.2,0.3-0.3,0.4c-0.3,0.4-0.6,0.8-0.9,1.2L15.1,26.3L14.7,26c-0.2-0.2-0.4-0.4-0.6-0.5'+
      'c-3.8-3.9-7.6-7.7-11.3-11.6c-2.7-2.8-3.5-6.1-2-9.2C2,1.9,4.7,0.1,7.7,0.1c2.9-0.2,5.7,1.4,7.1,4.1c0.1,0.1,0.2,0,0.2,0'+
      'c1-1.8,2.6-3.2,4.6-3.8c2-0.6,4.1-0.5,5.9,0.5C25.7,1,25.8,1.1,26,1.2C29.7,3.4,30.9,8.2,28.7,11.9z"></path>'+
      '</svg>'+
      '<span class="swym-tooltip swym-inject"><span class="swym-tooltip-text"></span></button>';

    addToCartHtml = 
      '<div class="product-btn '+add_perent_class+'">'+
//       '<a class="btn btn--full single-prod-btn'+ isDisabled +'"'+ isDisabled +' data-product-id="'+ variant_id +'">'+ cta_text +'</a>'+
      '<a href="'+btn_url+'" class="'+btn_class+'" data-product-id="'+ variant_id +'">'+ cta_text +'</a>'+
      btn_wishlist+
      '</div>';

    return {
      cta_btn: addToCartHtml,
    };

  }

  /************************** END BUILD PRODUCT LIST **************************/

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    var paginationHtml = '';
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {

      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      //$('html, body').animate({scrollTop:$('#CollectionAjaxResult').offset().top-100},'slow');
      
      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }
    return '';
  };

  /************************** BUILD TOOLBAR **************************/

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = '';
    var sortingArr = Utils.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
    }
    return html;
  };

  /* buildExtraProductList */
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;
    
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function(swat) { 
      // Wrap with callback for loading without additional checks
      var products = [];
      data.forEach(function(product) {
//         console.log("PRODUCT ::",product);
        var image_src = Utils.getFeaturedImage(product.images_info);
        var productCopy = product;
        productCopy.featured_image = image_src;
        productCopy.price = product.price_min; // Sometimes I need to multiply the price with 100
        productCopy.compare_at_price = product.compare_at_price_min; // Sometimes I need to multiply the price with 100
        products.push(productCopy);
      });
      swat.mapShopifyProducts(products); // Product mapped data to swym layer
      swat.initializeActionButtons('.boost-pfs-filter-products'); // Buttons can now be initialized
    });
    /** End Swym integration **/
    
    if (Utils.isSearchPage()) {
      this.buildExtrasProductListByAjax(data, 'boost-custom-swatch-search', function(results) {
        results.forEach(function(result) {
          jQ('.grid__item[data-id="' + result.id + '"]').find('.grid-product__colors').append(result.swatch);
        });
      });
    } else {
      this.buildExtrasProductListByAjax(data, 'boost-custom-swatch', function(results) {
        results.forEach(function(result) {
          jQ('.grid__item[data-id="' + result.id + '"]').find('.grid-product__colors').append(result.swatch);
        });
      });
    }
    
    
    $(document).on('mouseover','.custom-color--swatch',function(){
      //     console.log("hii")
      var $_this = $(this),
          product_image = $_this.data("product--image");
      $_this.parents(".grid-product__content").find(".grid__image-ratio .product-image--main").attr('srcset',product_image);
    });
    $(document).on("mouseout",'.custom-color--swatch',function(){
      var $_this = $(this),
          product_image = $_this.data("current-product--image");
      $_this.parents(".grid-product__content").find(".grid__image-ratio .product-image--main").attr('srcset',product_image);
    });
  };

  /* buildAdditionalElements */
  FilterResult.prototype.afterRender = function(data, eventType) {
    if (data != undefined){ 
      data = this.data;
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(function(swat) { 
        // Wrap with callback for loading without additional checks
        var products = [];
        data.forEach(function(product) {
          var image_src = Utils.getFeaturedImage(product.images_info);
          var productCopy = product;
          productCopy.featured_image = image_src;
          productCopy.price = product.price_min; // Sometimes I need to multiply the price with 100
          productCopy.compare_at_price = product.compare_at_price_min; // Sometimes I need to multiply the price with 100
          products.push(productCopy);
        });
        swat.mapShopifyProducts(products); // Product mapped data to swym layer
        swat.initializeActionButtons('.boost-pfs-filter-products'); // Buttons can now be initialized
      });
      /** End Swym integration **/
      // Call theme init function
      //wrap all javascript use theme in window.ready event to make sure theme init and register sections successfully
      jQ(document).ready(function() {
        if (typeof theme !== null && window.theme) {
          if(typeof AOS != 'undefined' && typeof AOS.refreshHard == 'function'){
            AOS.refreshHard();
          }
          // Setup page transition classes
          if (typeof theme.pageTransitions == 'function') {
            theme.pageTransitions();
          }

          // Quickview button: Use boost otp & otp style 3, disable add to cart

          // // Reload products inside each quick shop
          // if (typeof sections !== null && sections) sections.register('product-template', theme.Product);
          if (window.$ && typeof $ == 'function') {
            $(window).off('popstate');
          }
        }

        if (isFirstLoad) {
          isFirstLoad = false;
        }

        jQ('.js-drawer-open-collection-filters').on('click', function() {
          jQ('.' + Class.filterOption).each(function() {
            var showMoreType = jQ(this).data('show-more-type');
            if (showMoreType && jQ(this).data('display-type') != 'range') {
              self.buildFilterShowMore(jQ(this).find('.' + Class.filterBlockContent), showMoreType);
            }
          });
        });
      });

      // Build total products text
      var totalProductText = '';
      if (data.total_product == 1) {
        totalProductText = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
      } else {
        totalProductText = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
      }
      jQ('.boost-pfs-filter-total-product').html(totalProductText);

      // Build filter button text on mobile
      var numSelectedFilter = jQ('.boost-pfs-filter-tree .boost-pfs-filter-selected-items .boost-pfs-filter-option-label').length;
      if (numSelectedFilter) {
        jQ('.js-drawer-open-collection-filters').addClass('btn--tertiary-active');
        jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter + ' (' + numSelectedFilter + ')');
      } else {
        jQ('.js-drawer-open-collection-filters').removeClass('btn--tertiary-active');
        jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter);
      }
    };
  }
})();